import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=344aa2cc"
import script from "./Estoque.vue?vue&type=script&lang=js"
export * from "./Estoque.vue?vue&type=script&lang=js"
import style0 from "./Estoque.vue?vue&type=style&index=0&id=344aa2cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports